import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import "./registerServiceWorker";

import firebase from "firebase/app";
import "firebase/auth";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowAltCircleDown,
  faArrowAltCircleUp,
  faArrowRight,
  faArrowLeft,
  faCheck,
  faSpinner,
  faTimes
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import Datetime from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
Vue.use(Datetime);

Vue.config.productionTip = false;

library.add(
  faArrowAltCircleDown,
  faArrowAltCircleUp,
  faCheck,
  faSpinner,
  faArrowRight,
  faArrowLeft,
  faTimes
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    firebase.initializeApp({
      apiKey: "AIzaSyCQsnMFWUMyM1l0p0RHe5AFg5bZmBsbh-8",
      authDomain: "pocketapp-f3d33.firebaseapp.com",
      databaseURL: "https://pocketapp-f3d33.firebaseio.com",
      projectId: "pocketapp-f3d33",
      storageBucket: "",
      messagingSenderId: "551685600533",
      appId: "1:551685600533:web:dd299da545cdf77e"
    });
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        store.dispatch("autoSignIn", user);
        store.dispatch("getUserSettings", { userId: user.uid });
      }
    });
  }
}).$mount("#app");
